// Помощник: из office.map_embed_url или координат строим src для iframe карты.
// Если есть готовый embed URL — отдаём его.
// Если есть только координаты — генерируем OpenStreetMap embed (без API-ключа).

export interface MapEmbedSource {
  map_embed_url?: string | null;
  latitude?: number | string | null;
  longitude?: number | string | null;
}

function toNum(v: unknown): number | null {
  if (v === null || v === undefined || v === '') return null;
  const n = typeof v === 'number' ? v : parseFloat(String(v));
  return Number.isFinite(n) ? n : null;
}

export function buildMapEmbedUrl(src: MapEmbedSource | null | undefined, zoom = 16): string | null {
  if (!src) return null;
  if (src.map_embed_url && src.map_embed_url.trim().length > 0) {
    return src.map_embed_url;
  }
  const lat = toNum(src.latitude);
  const lon = toNum(src.longitude);
  if (lat === null || lon === null) return null;
  // bbox с радиусом ~0.005° (≈500 м) вокруг точки.
  const d = 0.5 / Math.pow(2, Math.max(0, zoom - 14));
  const left = lon - d;
  const right = lon + d;
  const top = lat + d / 2;
  const bottom = lat - d / 2;
  const bbox = `${left.toFixed(6)},${bottom.toFixed(6)},${right.toFixed(6)},${top.toFixed(6)}`;
  const marker = `${lat.toFixed(6)},${lon.toFixed(6)}`;
  return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${marker}`;
}
